import type { ChannelConfig } from '~/utils/useChannelConfig';

let _channelConfig: ChannelConfig | null = null;

// Called by root.tsx (SSR and CSR)
export function setChannelConfig(config: ChannelConfig) {
  _channelConfig = config;
}

// Called anywhere (helpers, utils, components)
export function getChannelConfig(): ChannelConfig {
  if (!_channelConfig) {
    throw new Error('ChannelConfig not initialized yet.');
  }
  return _channelConfig;
}

// Safe getter for default currency (returns fallback if not initialized)
export function getDefaultCurrency(fallback = 'CZK'): string {
  return _channelConfig?.defaultCurrency ?? fallback;
}

// Safe getter for default channel (returns fallback if not initialized)
export function getDefaultChannel(fallback = 'CZ'): string {
  return _channelConfig?.defaultChannel ?? fallback;
}
